/**
 * Qué se le exige a una contraseña.
 *
 * Vive acá para que la API y la pantalla pidan **lo mismo**: si el texto de
 * ayuda dice una cosa y el validador otra, la persona escribe lo que le
 * pidieron y el formulario la rechaza sin explicar por qué.
 *
 * La regla es una mayúscula y un caracter especial, sin mínimo de largo. Es una
 * decisión del producto: la política anterior pedía diez caracteres y frenaba a
 * gente que está cursando un tratamiento. Vale decir que el largo es lo que más
 * pesa contra un ataque por fuerza bruta —una frase larga resiste mucho más que
 * "Ab!"—, así que esto se apoya en el limitador de intentos del login, que sigue
 * en pie: diez por usuario y treinta por IP cada quince minutos.
 */
/** El texto que ve quien está escribiendo. Uno solo, y el mismo en todos lados. */
export const PASSWORD_HINT = 'Debe tener al menos una mayúscula y un caracter especial';
const UPPERCASE = /[A-ZÁÉÍÓÚÜÑ]/;
/** Todo lo que no sea letra ni número. Incluye el espacio: una frase vale. */
const SPECIAL = /[^\p{L}\p{N}]/u;
/** Qué le falta, si le falta algo. `null` cuando está bien. */
export function passwordProblem(value) {
    if (!value)
        return 'Escribí una contraseña';
    if (!UPPERCASE.test(value))
        return PASSWORD_HINT;
    if (!SPECIAL.test(value))
        return PASSWORD_HINT;
    return null;
}
export function isPasswordValid(value) {
    return passwordProblem(value) === null;
}
//# sourceMappingURL=password.js.map